module.exports = __webpack_public_path__ + "img/prop-lion.5021f757.webp";